module.exports = __webpack_public_path__ + "img/camera_light.5e7ffe99.svg";